export enum PaymentMethod {
    none = 0,
    usdtErc20 = 1,
    usdtTrc20 = 2,
    googlePay = 3,
    applePay = 4,
    monero = 5,
    openBanking = 6,
    creditCard = 7,
    tron = 8,
    ethereum = 9,
    bitcoin = 10,
    payPal = 11,
    cardMember = 13,
    peerToPeer = 14,
    unionPay = 15,
    alternativePayment = 16,
    demoPay = 17,
    usdcErc20 = 18
}